import {ABOUT_INFO_LIST,ABOUT_INFO_SUCCESS,ABOUT_INFO_ERROR } from "../../../redux/contants";

const INIT_STATE = {
    getAboutInfoList: [],
    loading: false,
    error: '',
    messages: ''
};
export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case ABOUT_INFO_LIST:
            // alert(action.type)
            // alert(action.data)
            return { ...state, loading: true, error: '' };
        case ABOUT_INFO_SUCCESS:
            console.log('ABOUT_INFO_LIST_SUCCESS===',action);
            return {
                ...state,
                loading: false,
                getAboutInfoList: action.data,
                error: '',
                messages: ''
            };
        case ABOUT_INFO_ERROR:
            return {
                ...state,
                loading: false,
                getAboutInfoList: [],
                error: action.error,
                messages: ''
            };
        default:
            return { ...state };
    }
};
